import { Redirect } from 'expo-router';

/**
 * Legacy add review route - now redirects to the new check-in flow
 */
export default function AddReviewRoute() {
  return <Redirect href="/(root)/check-in" />;
}
